// extracted by mini-css-extract-plugin
export var autoExpand = "_40-8";
export var container = "_40-7";
export var containerWidth = "_40-5";
export var disabled = "_40-2";
export var error = "_40-3";
export var fullWidth = "_40-6";
export var inputWrapper = "_40-0";
export var small = "_40-1";
export var textarea = "_40-4";